// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"styles_loadingPage__3Gl_s","content":"styles_content__a3uov"};